// removed by extract-text-webpack-plugin
module.exports = {"wrapper-header":"magazines_j-wNC","wrapper-header__content":"magazines_I8ZtT","wrapper-header__logo":"magazines_uMpWm","wrapper-header__magazine":"magazines_1MG8Y","wrapper-header__name":"magazines_3OF8R","wrapper-header__divider":"magazines_1OnF5","wrapper-header__none":"magazines_2pR-S","preview":"magazines_Adrzr","exported-pdfs":"magazines_17NXX","saving-message":"magazines_1jy4t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Heade/styles.scss
// module id = 999
// module chunks = 1